<template>
  <div>
    <hi-card v-for="(item, index) in supplierList" :key="index" :row-index="index + 1">
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>供货品类名称：</span>
        <span>{{ item.catgName }}</span>
      </van-row>
      <van-row>
        <span>供应商企业属性：</span>
        <span>{{ item.enterpriseNature | dictFilter(enterpriseNatureOptions) }}</span>
      </van-row>
      <van-row>
        <span>代理品牌：</span>
        <span>{{ item.agentBrand }}</span>
      </van-row>
      <van-row>
        <span>原厂名称：</span>
        <span>{{ item.agentFactory }}</span>
      </van-row>
      <van-row>
        <span>交易方式：</span>
        <span>{{ item.transactionForm | dictFilter(transactionFormOptions) }}</span>
      </van-row>
      <van-row>
        <span>潜在供应商分类：</span>
        <span>{{ item.level | dictFilter(levelOptions) }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'SupplierInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    supplierList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    enterpriseNatureOptions() {
      return this.$store.getters.dicts.enterprise_type
    },
    transactionFormOptions() {
      return this.$store.getters.dicts.trade_type
    },
    levelOptions() {
      return this.$store.getters.dicts.supp_level
    }
  }
}
</script>
